import { render, staticRenderFns } from "./ReviewTextAnalysis.vue?vue&type=template&id=bc2bdc02&scoped=true&"
import script from "./ReviewTextAnalysis.vue?vue&type=script&lang=js&"
export * from "./ReviewTextAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTextAnalysis.vue?vue&type=style&index=0&id=bc2bdc02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2bdc02",
  null
  
)

export default component.exports